import {
  LOGNOTAPPLICABLE,
  LOGAUTHORISED,
  LOGSUCCESS,
  LOGERROR_LOGGING_LEVEL_ERROR,
  LOGSOURCE,
} from "../configurations/Constants";
import { ERROR_SENDING_MESSAGE_TO_QUEUE } from "../configurations/MessageConstants";
import SQSHelper from "./SQSHelper";

const FluentdHelper = {
  logEvent(
    message = LOGNOTAPPLICABLE,
    function_name = LOGNOTAPPLICABLE,
    user_id = LOGNOTAPPLICABLE,
    object = LOGNOTAPPLICABLE,
    type = LOGSUCCESS,
    log_level = LOGERROR_LOGGING_LEVEL_ERROR,
    source = LOGSOURCE,
    name = LOGAUTHORISED
  ) {
    const log_object = {
      message: message,
      name: name,
      type: type,
      object: object,
      function_name: function_name,
      log_level: log_level,
      user_id: user_id,
      source: source,
    };
    try {
      SQSHelper.sendMessageToLogQueue(log_object);
      return log_object;
    } catch (error) {
      console.error(ERROR_SENDING_MESSAGE_TO_QUEUE, error);
      return log_object;
    }
  },
};
export default FluentdHelper;
